function CartValidationAlert({ cartResult, error }) {
  const hasErrors = Boolean(cartResult?.errors?.length);
  const hasWarnings = Boolean(cartResult?.warnings?.length);

  if (!error && !hasErrors && !hasWarnings) {
    return null;
  }

  return (
    <div className={`cart-alert ${hasErrors || error ? "cart-alert--error" : "cart-alert--warning"}`}>
      {error ? <p>{error}</p> : null}
      {cartResult?.errors?.map((itemError, index) => (
        <p key={`error-${index}`}>{itemError.message}</p>
      ))}
      {cartResult?.warnings?.map((warning, index) => (
        <p key={`warning-${index}`}>{warning.message}</p>
      ))}
    </div>
  );
}

export default CartValidationAlert;
